import React from "react";
import "./styles.scss";
import {
  agilent,
  IDT,
  Batelle,
  NEB,
  OpenPhil,
  Beckman,
  Twist,
  Benchling,
  Ginkgo,
} from "../../../../assets/media";

export const Sponsors = (): JSX.Element => (
  <div className="sponsors">
    <div className="sponsors-wrapper">
      <h1 className="sponsors-title">Sponsors</h1>
      <div className="sponsors-main">
        <h2>Platinum Partner</h2>
        <div className="sponsors-links">
          <a
            href="https://2021.igem.org/Sponsors/IDT"
            target="_blank"
            rel="noreferrer"
          >
            <img src={IDT} alt="sponsor-idt" />
          </a>
          <a
            href="https://2021.igem.org/Sponsors"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Ginkgo} alt="sponsor-Ginkgo" />
          </a>
        </div>
        <div className="sponsors-links">
          <a
            href="https://www.openphilanthropy.org/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={OpenPhil} alt="sponsor-openphil" />
          </a>
          <a
            href="https://2021.igem.org/Sponsors"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Twist} alt="sponsor-twist" />
          </a>
        </div>
        <h2>Partner</h2>
        <div className="sponsors-links partner">
          <a
            href="https://2021.igem.org/Sponsors/Beckman_Coulter"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Beckman} alt="sponsor-beckman" />
          </a>
          <a
            href="https://2021.igem.org/Sponsors/Benchling"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Benchling} alt="sponsor-benchling" />
          </a>
        </div>
      </div>
      <div className="sponsors-other">
        <h2>Gold</h2>
        <div className="sponsors-links">
          <img src={agilent} alt="sponsor-agilent" />
          <img src={Batelle} alt="sponsor-batelle" />
          <img src={NEB} alt="sponsor-neb" />
        </div>
      </div>
    </div>
  </div>
);
